export const internshipDesc = [
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img1_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img1_m.png',
    step: '01',
    title: '실무 경험으로 완성하는 경쟁력',
    desc: ['실제 기업 프로젝트 참여로 경쟁력있는 포트폴리오를 완성해요'],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img2_re_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img2_re_m.png',
    step: '02',
    title: '취업 연금술의 비법 전수',
    desc: ['이력서부터 포트폴리오까지, 취업 연금술의 모든 비법을 전수받아요'],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img3_re_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img3_re_m.png',
    step: '03',
    title: '임팩트있게 압축된 한 달',
    desc: ['빠른 취업을 위해 실무의 정수를 압축하여 실전 경험을 쌓아요'],
  },
  {
    imgUrlPc: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img4_pc.png',
    imgUrlM: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section4_img4_m.png',
    step: '04',
    title: '추천서로 빛나는 커리어',
    desc: ['우수 참가자에게는 취업 추천서 발급 기회를 제공해요'],
  },
]

export const pointDesc = [
  {
    step: '채용 공고 1',
    title: '크림 Android 서비스 개발자',
    desc1: 'Kotlin 개발에 능숙하신 분',
    desc2: 'Android 최신 트렌드를 이용한 경험이 있으신 분',
  },
  {
    step: '채용 공고 2',
    title: '코인원 Android 개발자',
    desc1: 'Java, Kotlin 언어 사용 능력이 있으신 분',
    desc2: 'Android SDK 및 API에 대한 이해가 있으신 분',
  },
  {
    step: '채용 공고 3',
    title: '삼쩜삼 Mobile Engineer',
    desc1: 'iOS 또는 Android Native 앱 개발 경험이 있는 분',
    desc2: 'Flutter 라이브러리 개발 경험이 있으신 분',
  },
]

export const curriculumSlideList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section6_slide_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section6_slide_img1_m.png',
    title: 'Java + Kotlin',
    descM: 'Android 개발 기초 언어인 Java와 Kotlin을 학습하고 \n개발자의 필수 역량을 다져요.',
    descPc: 'Android 개발 기초 언어인 Java와 Kotlin을 학습하고 \n개발자의 필수 역량을 다져요.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section6_slide_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section6_slide_img2_m.png',
    title: 'Android + 프로젝트',
    descM: 'Android의 기본 구조와 핵심 기술을 학습하고 \n실무 역량을 완성해요.',
    descPc: 'Android의 기본 구조와 핵심 기술을 학습하고 \n실무 역량을 완성해요.',
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section6_slide_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section6_slide_img3_m.png',
    title: 'Flutter + 프로젝트',
    descM: 'Flutter를 통해 상태관리와 플랫폼 채널 기술을 다듬고 \n완성도 높은 앱을 만들어요.',
    descPc: 'Flutter를 통해 상태관리와 플랫폼 채널 기술을 다듬고 \n완성도 높은 앱을 만들어요.',
  },
]

export const curriculumDetailList = [
  {
    id: 0,
    step: '1~3주차',
    title: 'Java',
    desc: '안드로이드 앱 개발을 위한 프로그래밍 언어인 Java를 학습합니다.',
    contents: [
      {
        contentsIntro: '자바 기초 문법',
        contentsInner: [
          '변수와 데이터 타입을 이해하여 프로그래밍 기초 개념 학습',
          '함수를 선언하고 호출하여 로직을 구조화 시키는 방법 이해',
          '조건문, 반복문 학습으로 로직 구현 능력 배양',
        ],
      },
      {
        contentsIntro: '객체 지향 프로그래밍',
        contentsInner: [
          '클래스를 선언하고 객체를 생성하는 방법을 이해하여 객체지향 개념 학습',
          '상속과 오버라이딩 기법에 대한 이해를 바탕으로 폴리모피즘 적용 능력 향상',
          '추상형과 접근 제어를 통해 객체지향 프로그래밍 능력 향상',
        ],
      },
      {
        contentsIntro: '자바 API 활용',
        contentsInner: [
          'java.lang 패키지: 기본 클래스 활용을 통해 효율적인 프로그래밍 능력 향상',
          'java.util 패키지: 데이터 구조 및 유틸리티 클래스 활용 능력 강화',
          'java.io 패키지: 입출력 처리 및 파일 관리 능력 고도화',
        ],
      },
    ],
  },
  {
    id: 1,
    step: '3~5주차',
    title: 'Android 기초',
    desc: '안드로이드 앱을 개발하기 위한 기본 구조 및 화면 구성 방법을 학습합니다.',
    contents: [
      {
        contentsIntro: '개발환경',
        contentsInner: [
          'Android 소개 및 핵심 구조 이해 학습',
          'Android Studio 를 중심으로 한 안드로이드 개발 환경 이해 및 구축',
          'AVD/ Phone 테스트를 통해 앱을 실행 시키는 방법 학습',
          '앱 배포를 위한 준비와 플레이스토어 배포 절차 이해',
        ],
      },
    ],
  },
  {
    id: 2,
    step: '5~6주차 미니 프로젝트',
    title: 'Android 기초',
    desc: 'Java 와 안드로이드 기초에서 학습한 내용을 바탕으로 안드로이드 앱의 \n동작 원리 및 기초 작성 방법을 이해하는 프로젝트를 진행합니다.',
  },
  {
    id: 3,
    step: '7~8주차',
    title: 'Kotlin',
    desc: '안드로이드 앱 개발을 위한 프로그래밍 언어인 Kotlin를 학습합니다.',
    contents: [
      {
        contentsIntro: 'Kotlin 기초 문법',
        contentsInner: [
          '코틀린에서 변수와 데이터 타입 활용 방법 학습',
          '함수를 선언하고 옵셔널을 적용하는 능력 향상',
          'Null Safety 개념과 Null Safety Operator 학습',
        ],
      },
      {
        contentsIntro: 'Kotlin 객체지향 프로그래밍',
        contentsInner: [
          '코틀린에서 클래스를 선언하는 방법과 객체를 생성하는 방법 학습',
          'Primary Constructor/ Secondary Constructor 을 구분하고 클래스를 설계하는 능력 향상',
          'Property 개념과 Property 적용 이점에 대한 이해 학습',
          'Data, Object, Sealed 등 코틀린의 다양한 클래스 확용 능력 향상',
        ],
      },
      {
        contentsIntro: '함수형 프로그래밍',
        contentsInner: [
          '람다 함수를 선언하고 적용하는 능력 향상',
          'High Order Function 개념과 사용 방법 학습',
          'run, let, apply 등 다양한 코틀린의 함수를 활용한 개발 능력 향상',
        ],
      },
      {
        contentsIntro: 'UI 프로그래밍',
        contentsInner: [
          'Layout 클래스들을 이용해 앱의 화면을 구성하는 방법 이해',
          '다양한 뷰를 활용해 원하는 화면을 구축하는 능력 향상',
          '다양한 User Event 처리 프로그램을 작성하는 능력 향상',
          '안드로이드의 리소스 종류와 활용 방법 학습',
        ],
      },
      {
        contentsIntro: '데이터 영속화',
        contentsInner: [
          '안드로이드 파일 스토리지 정책과 사용시 방법 학습',
          'SharedPreference 을 이용해 앱의 데이터를 영속적으로 저장하는 능력 향상',
          'Database을 이용해 앱의 데이터를 구조화 시켜 저장하는 능력 향상',
        ],
      },
    ],
  },
  {
    id: 4,
    step: '9~11주차',
    title: 'Android 핵심',
    desc: '안드로이드 앱 개발에 필요한 다양한 기술을 학습합니다.',
    contents: [
      {
        contentsIntro: 'Android Component',
        contentsInner: [
          'Activity의 라이프사이클을 이해하고 Intent 활용능력 향상',
          'BroadcastReceiver의 특징을 활용한 다양한 시스템 상황 파악',
          'Service 의 동작 원리와 백그라운드 제약에 대한 이해',
          'ContentProvider의 개념과 안드로이드 기본 앱의 프로바이더 활용 능력 향상',
        ],
      },
      {
        contentsIntro: '네트워킹',
        contentsInner: [
          'Retrofit을 활용한 네트워크 프로그램 작성 방법 이해',
          'Socket 프로그래밍을 통해 실시간 서버 데이터 활용 능력 향상',
          'Firebase Cloud Message를 이용한 서버 데이터 활용 능력 향상',
        ],
      },
      {
        contentsIntro: '다양한 기술',
        contentsInner: [
          '위치정보를 획득하는 방법과 지도를 출력하는 방법 학습',
          'Notification을 통해 다양한 정보를 유저에게 제공하는 능력 향상',
          'Bluetooth를 이용한 근접 기기 통신 방법 학습',
          'SMS를 발송하고 수신하는 방법 학습',
          'Gallery 앱과 Contacts 앱을 연동해 다양한 기능을 구현하는 능력 향상',
          'Camera를 제어해 실시간 사진 촬영 및 영상 녹화를 구현하는 능력 향상',
          'Sensor를 활용해 다양한 데이터 획득 방법 학습',
        ],
      },
    ],
  },
  {
    id: 5,
    step: '11~13주차',
    title: 'Android 심화',
    desc: 'Jetpack에서 제공하는 AAC 와 Compose를 안드로이드 앱에 적용하는 방법을 학습합니다.',
    contents: [
      {
        contentsIntro: 'Coroutine',
        contentsInner: [
          '다양한 Coroutine Scope를 만드는 방법을 학습',
          '다양한 Coroutine Builder를 학습해 적재적소에 필요한 코루틴을 활용하는 능력 향상',
          'Flow를 이용해 연속적인 데이터 흐름을 핸들링 하는 능력 향상',
        ],
      },
      {
        contentsIntro: 'AAC',
        contentsInner: [
          'ViewModel/LiveData 구조를 적용해 MVVM 패턴에 입각한 앱 개발 능력 향상',
          'Room을 이용해 앱의 데이터를 저장하고 이용하는 능력 향상',
          'Paging을 이용한 RecyclerView 활용 기법 학습',
        ],
      },
      {
        contentsIntro: 'Compose',
        contentsInner: [
          '선언형 UI 프로그래밍에 대한 이해와 Compose 로 화면 구성하는 방법 학습',
          'Compose 에서 제공하는 다양한 컴포저블을 활용해 앱의 화면을 구성하는 방법 학습',
          'Compose 의 상태 관리 기법을 활용해 앱의 데이터를 구조화 시켜 이용하는 능력 향상',
        ],
      },
    ],
  },
  {
    id: 6,
    step: '14~15주차',
    title: 'Flutter',
    desc: '크로스 플랫폼 앱 개발 프레임워크인 Flutter로 앱을 개발하는 방법을 학습합니다.',
    contents: [
      {
        contentsIntro: 'Dart',
        contentsInner: [
          '다트 언어의 변수, 함수, 제어문 등 기초 문법 학습',
          '다트 언어의 객체지향 프로그래밍 기법 학습',
        ],
      },
      {
        contentsIntro: 'UI Programming',
        contentsInner: [
          '위젯에 대한 이해와 StatefulWidget/ StatelessWidget 을 작성하는 방법에 대한 이해',
          '다양한 Flutter의 위젯을 활용한 화면 구성 능력 향상',
          'Navigation API 를 이용한 화면 전환 능력 향상',
        ],
      },
      {
        contentsIntro: '상태관리',
        contentsInner: [
          '상태관리 개념과 Flutter의 상태관리 API 학습',
          'Provider를 활용한 효율적인 앱 상태 관리 능력 강화',
          'BLoC을 통한 체계적인 상태 관리 능력 향상',
        ],
      },
    ],
  },
  {
    id: 7,
    step: '16~19주차 파이널 프로젝트 1',
    title: 'Flutter',
    desc: '크로스 플랫폼 프레임워크인 Flutter를 활용하여 상태관리 기술로 데이터를 효율적으로 관리하고, \n플랫폼 채널을 통해 다양한 기능을 구현하는 프로젝트를 진행합니다.',
  },
  {
    id: 8,
    step: '20주차 세미 프로젝트',
    title: 'Android 핵심/심화',
    desc: '안드로이드 핵심/심화에서 학습한 실전 기술을 바탕으로 AAC 및 Compose를 \n적용하여 최신 안드로이드 앱 개발 기술을 이해할 수 있는 프로젝트를 진행합니다.',
  },
  {
    id: 9,
    step: '21~26주차 파이널 프로젝트 2',
    title: 'Android',
    desc: '팀 단위, 자율 주제로 진행되는 프로젝트로 교육과정에서 학습한 안드로이드 앱 개발 \n기술을 모두 동원해 포트폴리오로 제시할 수준의 앱을 개발하는 프로젝트를 진행합니다.',
  },
]

export const projectSlideList = [
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img1_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img1_m.png',
    title: '미니 프로젝트 - Android 기초',
    descM:
      'Java와 안드로이드 기초에서 학습한 내용을 바탕으로 \n안드로이드 앱의 동작 원리 및 기초 작성 방법을 익혀요',
    descPc:
      'Java와 안드로이드 기초에서 학습한 내용을 바탕으로 \n안드로이드 앱의 동작 원리 및 기초 작성 방법을 익혀요',
    details: [
      {
        contentsId: '1',
        contentsInner: [
          '자바 언어에 대한 활용 능력 향상',
          '다양한 화면 구성하는 방법에 대한 학습',
          '다양한 리소스를 활용해 앱을 구성하는 방법 학습',
          '파일, Preference, Database 등 다양한 방법으로 앱의 데이터를 영속화 시키는 방법 학습',
        ],
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img3_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img3_m.png',
    title: '파이널 프로젝트1 - Flutter',
    descM:
      '크로스 플랫폼 프레임워크인 Flutter를 이용하여 상태관리 기술로 데이터를 관리하고, 플랫폼 채널을 이용하여 \n다양한 기능을 서비스 할 수 있는 프로젝트를 진행해요.',
    descPc:
      '크로스 플랫폼 프레임워크인 Flutter를 이용하여 상태관리 기술로 데이터를 관리하고, 플랫폼 채널을 이용하여 \n다양한 기능을 서비스 할 수 있는 프로젝트를 진행해요.',
    details: [
      {
        contentsId: '2',
        contentsInner: [
          'Flutter 아키텍처에 대한 명확한 이해',
          '다양한 위젯들을 이용해  앱 화면 구성 능력 향상',
          '다양한 패키지를 이용한 앱 상태관리 능력 향상',
          '앱을 안드로이드/iOS로 빌드, 배포하는 방법 학습',
        ],
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img2_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img2_m.png',
    title: '세미 프로젝트 - Android 핵심/심화',
    descM:
      '안드로이드 핵심/심화에서 학습한 실전 기술을 \n바탕으로 AAC 및 Compose를 적용하여 최신 \n안드로이드 앱 개발 기술을 경험해요',
    descPc:
      '안드로이드 핵심/심화에서 학습한 실전 기술을 \n바탕으로 AAC 및 Compose를 적용하여 최신 \n안드로이드 앱 개발 기술을 경험해요',
    details: [
      {
        contentsId: '3',
        contentsInner: [
          'Compose를 이용한 선언형 UI 및 앱 상태 관리',
          'AAC에서 제공하는 다양한 아키텍처 요소를 적절하게 앱에 적용',
          'Coroutine을 한 앱 비동기 프로그램 작성 방법',
          '네트워킹을 통해 서버 데이터를 활용하는 방법',
        ],
      },
    ],
  },
  {
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img4_pc.png',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section7_slide_img4_m.png',
    title: '파이널 프로젝트2 - Android',
    descM:
      '팀 단위, 자율 주제로 진행되는 프로젝트로 교육과정에서 \n학습한 안드로이드 앱 개발 기술을 모두 동원해 \n포트폴리오로 제시할 수준의 앱을 개발해요.',
    descPc:
      '팀 단위, 자율 주제로 진행되는 프로젝트로 교육과정에서 \n학습한 안드로이드 앱 개발 기술을 모두 동원해 \n포트폴리오로 제시할 수준의 앱을 개발해요.',
    details: [
      {
        contentsId: '4',
        contentsInner: [
          'Gallery, Contacts, Camera 등 다양한 폰의 기능을 연결하는 앱 개발 능력',
          'Compose, AAC, Coroutine 등 최신 트렌드에 맞는 기술을 적용한 앱 개발 능력',
          '안드로이드 앱을 빌드, 배포하는 방법',
        ],
      },
    ],
  },
]

export const projectOutputList = [
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section8_video1.mp4',
    title: '다온길 | 여행',
    who: '2기 수료생 제작',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section8_video2.mp4',
    title: '모두다임 | 스터디',
    who: '2기 수료생 제작',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section8_video3.mp4',
    title: 'CMarket | 쇼핑',
    who: '2기 수료생 제작',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section8_video4.mp4',
    title: '스케쥴윗 | 일정 관리',
    who: '2기 수료생 제작',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section8_video5.mp4',
    title: '우연히 | 커플',
    who: '2기 수료생 제작',
  },
  {
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section8_video6.mp4',
    title: '아파트톡 | 커뮤니티',
    who: '2기 수료생 제작',
  },
]

export const prepareFirstDetailList = [
  {
    id: 0,
    step: 'Part 1',
    title: '이론학습',
    contents: [
      {
        contentsInner:
          '기본 자료구조 학습부터 정렬, 탐색, 동적 프로그래밍 등 코딩테스트 필수 유형의 기본 이론을 학습하면서 다지는 기본기',
      },
    ],
  },
  {
    id: 1,
    step: 'Part 2',
    title: '프로그래머스 & 백준 실시간 라이브 코딩',
    contents: [
      {
        contentsInner:
          '이론 학습 후 이론과 관련된 프로그래머스 & 백준 문제를 멘토님과 실시간으로 라이브 코딩하면서 응용력 및 문제해결능력 강화',
      },
    ],
  },
]

export const prepareSecondDetailList = [
  {
    id: 0,
    title: '자료구조',
    contents: [
      {
        contentsIntro: '알고리즘 성능',
        contentsInner: '시간복잡도, 공간복잡도',
      },
      {
        contentsIntro: '선형 자료구조',
        contentsInner: 'stack, queue, heap',
      },
      {
        contentsIntro: '비선형 자료구조',
        contentsInner: '트리 & 그래프',
      },
    ],
  },
  {
    id: 1,
    title: '알고리즘',
    contents: [
      {
        contentsIntro: '정렬 기초',
        contentsInner: '선택/삽입/버블',
      },
      {
        contentsIntro: '탐색',
        contentsInner: '이분탐색, 재귀함수(순열포함), BFS/DFS, 백트래킹',
      },
      {
        contentsIntro: '심화구현',
        contentsInner: '그리디, 투포인터',
      },
      {
        contentsIntro: '동적 프로그래밍',
        contentsInner: 'DP(동적계산법)',
      },
    ],
  },
]

export const programDetailList = [
  {
    id: 0,
    title: '자기 탐색',
    contents: [
      {
        contentsIntro: '취업 특강',
        contentsInner: '산업 분석, 자기 분석, 취업 전략 도출',
      },
      {
        contentsIntro: '개별 상담',
        contentsInner: '진로 탐색, 취업 로드맵 수립, 포트폴리오 작업 방향성 탐색',
      },
    ],
  },
  {
    id: 1,
    title: '역량 강화',
    contents: [
      {
        contentsIntro: '취업 특강',
        contentsInner: '기업 분석, 직무 분석, 입사 서류 및 포트폴리오 작성법, 면접의 이해',
      },
      {
        contentsIntro: '현직자 특강',
        contentsInner: '수강생 니즈에 맞춘 현직 안드로이드 앱 개발자의 특강',
      },
      {
        contentsIntro: '개별 상담',
        contentsInner: '이력서 특강',
      },
    ],
  },
  {
    id: 2,
    title: '수료 후 취업',
    contents: [
      {
        contentsInner: '멋사 내 취업 지원 페이지에서 커리어 코치와 상담 신청',
      },
      {
        contentsInner: '교육 과정 수료 이후에도 지속적인 구직활동 현황 체크',
      },
      {
        contentsInner: '개인 맞춤형 취업지원 제공',
      },
      {
        contentsInner:
          '수료 후 상시로 진행되는 취업 박람회, 특강, 우선채용 기회 제공 : IT 맞춤형 채용설명회 진행',
      },
    ],
  },
]

export const reviewList = [
  {
    title: '안드로이드 개발자로써 정말 큰 성장을 \n할 수 있었습니다.',
    desc: '6개월 동안 강사님의 강의, 프로젝트를 통한 협업, 그리고 이 앱 스쿨을 듣는 가장 큰 의미가 있었던 멘토링. 이 훈련과정을 듣지 않았다면 안드로이드 개발자로써 지금 만큼 절대 성장할 수 없었을 것 같습니다. 6개월동안 수고해주신 운영진분들, 강사님, 멘토님들께 평생 감사하며 살겠습니다.',
    who: '2기 수료생 후기',
  },
  {
    title: '아직 부족한 면이 많겠지만 그래도 어느정도 할 수 있다는 자신감 또한 생겨서 좋았습니다.',
    desc: '앱 개발자가 되고 싶어 하드적인 스킬을 전혀 몰랐던 상황이었는데 이 훈련 과정을 강사님과 멘토님들을 통해 많은걸 배웠고, 직접 프로젝트를 팀원들과 협업하여 하나의 앱을 만들어 또한 많은 배움들이 있었습니다.',
    who: '2기 수료생 후기',
  },
  {
    title: '온라인 과정임에도 배우는데 큰 어려움이 없었습니다.',
    desc: '수업도 좋았고 강사님 멘토님 운영진님들 모두 열의를 가지고 임하셔서 온라인 과정임에도 배우는데 큰 어려움이 없었습니다.',
    who: '2기 수료생 후기',
  },
  {
    title: '23주간 개인적으로 앱개발 실력이 크게 향상되었음을 느낍니다',
    desc: '운영진분들과 강사님들이 서포트를 너무 잘해주셨던 결과인 거 같습니다. 온라인 수업이었지만 오프라인 수업만큼 집중할 수 있었고 좋은 경험과 추억으로 기억에 남을 거 같습니다 힘써주신 강사님들과 운영진분들께 다시 한번 감사드립니다!',
    who: '1기 수료생 후기',
  },
  {
    title: '5개월 간 많은 걸 배우며 성장할 수 있었던 시간이었습니다.',
    desc: '강사님, 멘토님, 운영진 분들 잘 이끌어주셔서 너무 감사했고 특히 운영진분들 끊임없이 수강생 점검하고 신경써주셔서 감사했습니다!',
    who: '1기 수료생 후기',
  },
]

export const benefitSlideList = [
  {
    title: '교육에 필요한 도서 지원',
    desc: '안드로이드 개발 1위 서적, 강성윤 주강사님의 \n<Do it 깡샘의 안드로이드 프로그래밍 with Kotlin>을 무상으로 지원해요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img1.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img1_pc.png',
  },
  {
    title: '교육비 전액 무료',
    desc: '내일배움카드로 약 1,700만원 상당의 교육을 \n무료로 들을 수 있어요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img2.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img2_pc.png',
  },
  {
    title: '훈련장려금 지급',
    desc: '매월 최대 81만 원의 훈련 지원금을 받을 수 있어요',
    option:
      '*단, 국민취업제도 참여 유형을 포함한 개인의 상황에 따라 다를 수 있으며 자세한 사항은 고용 24에서 확인해 주세요.',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img3.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img3_pc.png',
  },
  {
    title: '교육 장비 지원',
    desc: '교육 시작 전, 교육 장비가 필요한 인원에 \n한하여 무료로 장비를 대여해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img4.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img4_pc.png',
  },
  {
    title: '오프라인 프로젝트 공간 지원',
    desc: '사전 신청자에 한하여 프로젝트를 진행할 수 \n있는 오프라인 공간을 지원해 드려요',
    imgUrlM:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img5.png',
    imgUrlPc:
      'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section15_benefit_img5_pc.png',
  },
]

export const EduScheduleList = [
  {
    title: '교육 기간',
    content: '2025년 3월 12일(수) ~ \n2025년 9월 2일(화)',
  },
  {
    title: '교육 시수',
    content: '26주 | 920H',
  },
  {
    title: '교육 시간',
    content: '평일 오전 9시 - 오후 6시 \n(일 8시간, 점심시간 제외)',
  },
  {
    title: '학습 형태',
    content: '실시간 온라인 교육',
  },
]

export const bootCampFaqTabList = [
  { label: '전체', value: 'all' },
  {
    label: '지원',
    value: 'apply',
  },
  {
    label: '선발',
    value: 'nebeka',
  },
  {
    label: '취업',
    value: 'employment',
  },
  {
    label: '교육운영',
    value: 'edu',
  },
  {
    label: '특전혜택',
    value: 'benefit',
  },
  {
    label: '기타',
    value: 'etc',
  },
]

interface IBootCampFaqList {
  [key: string]: {
    question: string
    answer?: string
    secondAnswer?: string
    externalUrl1?: string
    urlName1?: string
    externalUrl2?: string
    urlName2?: string
    answerList?: string[]
  }[]
}

export const bootCampFaqList: IBootCampFaqList = {
  apply: [
    {
      question: '[지원] 지원 자격이 있나요?',
      answer:
        '국민내일배움카드를 보유하고 있거나 발급 가능하다면 누구든지 지원하실 수 있습니다. 발급 가능 여부는 고용노동부 1350 또는 거주지 관할 고용센터에서 직접 확인해주셔야 합니다. \n국민내일배움카드를 발급받고 교육 기간 동안 주 5일, 매일 약 8시간의 교육 과정에 온전히 참여하실 수 있다면 원칙상 수강할 수 있으나, 직장과 병행해야 해서 정해진 시간에 출석할 수 없고 하루 8시간의 학습 시간을 채울 수 없는 경우 선발에서 제외됨을 알려드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드가 없어도 지원할 수 있나요?',
      answer:
        '지원은 가능합니다. 다만 최종 합격 발표 전까지는 모바일 앱 카드 혹은 실물 카드를 소지하고 있으셔야 합니다. \n모바일 앱 카드의 경우, 신청 당일에 즉시 발급이 가능하지만 오프라인 카드 발급은 최종 수령까지 일주일 이상 소요될 수 있기에 고용노동부 1350을 통해 카드 발급 자격 확인 및 발급 신청을 빠르게 하시는 것을 추천드립니다.',
    },
    {
      question: '[지원] 국민내일배움카드는 어떻게 발급 받나요?',
      answer:
        '국민내일배움카드는 고용24 홈페이지를 통해 신청 가능하며 오프라인과 온라인 모두 발급 받으실 수 있습니다.',
      externalUrl1: '/nebeca',
      urlName1: '국민내일배움카드 신청 방법 확인하기 (링크)',
      externalUrl2: '/nebeca/issued',
      urlName2: '국민내일배움카드 모바일 발급 방법 확인하기 (링크)',
    },
    {
      question: '[지원] 비전공자도 지원 가능한가요?',
      answer:
        '네. 지원 가능합니다. 전공과 무관하게 안드로이드 앱 개발자가 되려는 강한 의지와 계획이 있으시면 됩니다. \n다만, 합격 후 6개월 동안 정말 몰입해서 학습을 이어가셔야 합니다. 꾸준한 의지와 학습 습관으로 목표하시는 변화를 만들어내시기 바랍니다.',
    },
    {
      question: '[지원] 다른 부트캠프와 중복 지원 가능한가요?',
      answer:
        '멋쟁이사자처럼이 운영하는 다른 부트캠프와 중복 지원은 불가합니다. 다른 훈련기관이 운영하는 과정에 중복 지원하는 것은 가능합니다. 희망하는 부트캠프에 한해 하나만 지원 가능하므로 신중하게 고민하고 선택해주세요.',
    },
    {
      question: '[지원] 고용24 수강신청은 언제 할 수 있나요?',
      answer:
        '최종 합격자로 선발된 후, 합격하신 분들께 별도로 안내해 드릴 예정입니다. \n안내를 받으신 후 고용24에서 신청해주시면 됩니다.',
    },
    {
      question: '[지원] 지원서 제출 후 수정 가능한가요?',
      answer: '지원서 수정은 불가능합니다. 항목을 미리 검토하신 후 제출하시기 바랍니다.',
    },
  ],
  nebeka: [
    {
      question: '[선발] 선발 절차는 어떻게 되나요?',
      answer:
        '국민내일배움카드 신청 → 1차 지원서(서류) 제출 → 서류 합격자 발표 → 2차 취업적합성 검사 → 최종합격자 발표 → 고용24 수강신청 순으로 진행됩니다. \n국민내일배움카드 발급에 일주일 이상 소요되므로 발급 신청을 먼저 해주시기 바랍니다.',
    },
    {
      question: '[선발] 2차 취업적합성 검사는 무엇인가요?',
      answer:
        '부트캠프 합류에 앞서 안드로이드 개발에 대한 기본 이해와 취업에 대한 의지를 확인하고자 하는 누구나 답할 수 있는 간단한 검사입니다.',
    },
    {
      question: '[선발] 합격 확인은 어떻게 하나요?',
      answer:
        '각 단계별로 합격하신 분들께는 E-mail과 SMS로 안내드릴 예정입니다. 발표 일정은 상세페이지를 참고해주세요. \n**발표 일정은 상황에 따라 일부 변경될 수 있습니다.',
    },
  ],
  employment: [
    {
      question: '[취업] 취업 지원 프로그램이 제공되나요?',
      answer:
        '총 3단계의 취업 지원 프로그램을 통해 최신 채용 트렌드를 반영한 전문적인 이력서 특강 및 피드백을 통한 취업 지원을 받으실 수 있으며 자세한 내용은 위 상세페이지 내에서 확인 가능합니다.',
    },
  ],
  edu: [
    {
      question: '[교육 운영] 이 부트캠프는 어떤 사람에게 적합한가요?',
      answer:
        '부트캠프를 수료하면 다음과 같은 직무로 취업할 수 있습니다. \n\n• 안드로이드 앱 개발자: Java, Kotlin, Android Studio를 활용한 네이티브 앱 개발\n• 크로스플랫폼 앱 개발자: Flutter를 활용한 Android 및 iOS 앱 동시 개발\n• 모바일 백엔드 개발자: 모바일 앱과 연동되는 서버 및 API 설계\n• 모바일 UI/UX 엔지니어: 앱 인터페이스 최적화 및 사용자 경험 개선\n\n이 과정은 IT 취업을 목표로 하는 비전공자, 모바일 앱 개발자로 커리어 전환을 희망하는 직장인, 신입 개발자로서 경쟁력을 높이고 싶은 취준생에게 적합합니다.\n특히, 팀 프로젝트 경험과 현직자의 실시간 피드백을 통해 실무 역량을 갖추고, 포트폴리오 제작 및 코딩 테스트 준비까지 지원받을 수 있어 취업 시장에서 차별화된 강점을 가질 수 있습니다.\n여러분의 커리어 목표와 부트캠프의 교육 방향이 맞는지 궁금하다면, 상담을 통해 더 자세히 확인해보세요!',
    },
    {
      question: '[교육 운영] 교육 기간 내 커리큘럼을 모두 소화할 수 있을까요?',
      answer:
        '충분히 가능합니다. 멋쟁이사자처럼의 안드로이드 개발 부트캠프는 **6개월 동안 단계적으로 구성된 커리큘럼**을 통해 초보자도 무리 없이 학습할 수 있도록 설계되었습니다. \n또한, 강사와 멘토진의 실시간 피드백과 1:1 맞춤 학습 지원 으로 학습 속도에 맞춰 진도를 따라갈 수 있습니다. 수료 후에는 안드로이드 앱 개발자로서 필요한 이론과 실무 역량을 모두 갖추게 되니 걱정하지 않으셔도 됩니다!',
    },
    {
      question: '[교육 운영] 교육은 어디서 진행되나요?',
      answer:
        '교육은 오프라인이 아닌, 온라인 라이브로 진행되며 국내에서, 거주 지역에 무관하게 학습할 수 있습니다.',
    },
    {
      question: '[교육 운영] 온라인 수업 출결은 어떻게 진행되나요?',
      answer:
        '두 가지 방법으로 출결이 진행됩니다.\n 1. 고용24 앱 설치 후 QR코드 인증(개인 진행)\n 2. 줌 모니터링을 통한 매시간 출결 체크(운영진 진행, 줌 화면에 얼굴이 정확히 확인되어야 출석 인정)\n추가로, 수업 참여 중 장소 이동은 불가합니다. 장소 이동 시 출결에 불이익이 발생하니 이점 유의 부탁드립니다.',
    },
    {
      question: '[교육 운영] 수업에 빠질 경우 강의를 다시 볼 수 있나요?',
      answer:
        '본 교육 과정은 학습을 포함한 모든 내용을 영상으로 추가 제공하지 않습니다. 따라서 다음 수업 내용을 잘 따라가기 위해서는 반드시 출석해 주셔야 합니다.',
    },
    {
      question: '[교육 운영] 교육 기간 중 쉬는 날은 없나요?',
      answer:
        '교육 기간 내 주말, 공휴일에는 교육을 진행하지 않습니다. 수업 외 일정에 관해서는 오리엔테이션에서 자세하게 안내드릴 예정입니다. 교육기간 6개월 동안 온전하게 몰입하시는 것을 권유드립니다.',
    },
    {
      question: '[교육 운영] 해외에서도 참여할 수 있나요?',
      answer:
        'KDT 프로그램의 특성상, 해외에서 수강하는 것은 불가능합니다. 교육 참여 중에 해외로 이동하는 것 역시 불가능합니다.',
    },
  ],
  benefit: [
    {
      question: '[특전 혜택] 합격생에게 제공되는 혜택이 있나요?',
      answerList: [
        '· 교육에 필요한 도서를 무상 지원합니다.',
        '· 멋쟁이사자처럼 수료생 커뮤니티 활동 기회를 제공합니다.',
        '· 인턴십 기회를 통해 차별화된 실무 경험을 제공합니다.',
        '· 수료 후 정기적으로 진행되는 행사 참여 및 네트워킹 기회를 제공합니다. (KDT 수료생에 한함)',
        '· 기초 학습 및 성장을 위한 유료 강의를 제공합니다.',
        '· 이력서 특강 등 개인 맞춤 성장 프로그램을 제공합니다.',
      ],
    },
  ],
  etc: [
    {
      question: '[기타] 훈련장려금을 받을 수 있나요?',
      answerList: [
        '· 네. 훈련 장려금은 월 최대 316,000원까지 받으실 수 있으며, 매달 출석률에 따라 차등 지급됩니다.',
        '· 국민취업제도에 참여 중인 분들의 경우, 훈련 장려금 외에 추가 훈련 수당을 받으실 수 있으며 1유형에 해당하시는 분들은 500,000원의 훈련수당까지 더해 월 최대 816,000원을 지급받으실 수 있고2유형에 해당하시는 분들은 284,000원의 훈련수당까지 더해 월 최대 600,000원을 지급받으실 수 있습니다. \n다만, 개인의 상황에 따라 참여 가능한 유형이 다르고 지급받을 수 있는 금액이 다를 수 있기에 반드시 고용24를 통해 확인 및 신청 바랍니다.',
      ],
    },
    {
      question: '[기타] 훈련 자비 부담액은 얼마인가요?',
      answer: '본 교육과정은 내일배움카드를 소지하신 분들을 대상으로 전액 무료로 진행됩니다.',
    },
  ],
}
